/**
 * Used in case we need to switch the secret for hashing the AppSync authorizer
 */
const graphQLHashVersion = "v0.0.2";
export default graphQLHashVersion;
